import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { UrlUtilsService } from '@rd/core/services/url-utils/url-utils.service';
import { BannerImageConfig } from '@rd/shared-legacy/widgets/banner-image/banner-image.component';
import { LoyaltyCurrency } from '@rd/types';

@Component({
  selector: 'rd-anz-tcv2-programs-banner',
  templateUrl: './programs-banner.componen.html',
  styleUrls: ['./programs-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnzTcV2ProgramsBannerComponent {
  @HostBinding('class') componentClasses =
    'rd-tcv2-programs-banner rd-anz-tcv2-programs-banner';

  @Input() loyaltyCurrencySelected: LoyaltyCurrency;

  bannerImageConfig: BannerImageConfig = {
    jpg: {
      desktop: this.urlUtilsService.imageUrl(
        '/images/TC_ProductMasterHead_Desktop.jpg',
      ),
      mobile: this.urlUtilsService.imageUrl(
        '/images/TC_ProductMasterHead_Mobile.jpg',
      ),
    },
    avif: {
      desktop: this.urlUtilsService.imageUrl(
        '/images/TC_ProductMasterHead_Desktop.avif',
      ),
      mobile: this.urlUtilsService.imageUrl(
        '/images/TC_ProductMasterHead_Mobile.avif',
      ),
    },
    webp: {
      desktop: this.urlUtilsService.imageUrl(
        '/images/TC_ProductMasterHead_Desktop.webp',
      ),
      mobile: this.urlUtilsService.imageUrl(
        '/images/TC_ProductMasterHead_Mobile.webp',
      ),
    },
  };

  constructor(private urlUtilsService: UrlUtilsService) {}

  bannerTitleTranslationParams(): { loyaltyCurrency: string } {
    return { loyaltyCurrency: this.loyaltyCurrencySelected.shortName };
  }
}
